const notebooksActionTypes = {
    SET_NOTEBOOKS_ARRAY:'SET_NOTEBOOKS_ARRAY',
    SET_NOTEBOOK:'SET_NOTEBOOK',
    SET_NOTE:'SET_NOTE'
}

export default notebooksActionTypes